import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { showToast } from './Toast';

// Redirects from a deprecated v1 surface (Companies, Customers — PRD-006)
// to its v2 replacement (/connections). Fires a one-time-per-session toast
// the first time the user hits the deprecated URL; subsequent same-session
// hits redirect silently (AC-3).
export default function LegacyRedirect({ to, sessionKey, headline, body }) {
  useEffect(() => {
    showToast({ sessionKey, headline, body });
  }, [sessionKey, headline, body]);

  return <Navigate to={to} replace />;
}
